import React from 'react'

import style from './ModalPayCancel.module.scss'
import { getBackgroundImageUrl } from '../../utils/imageEncodeUrl'

const ModalPayCancelInfo = ({ btnClose, handleCloseModal, orderData, cancelInfo }) => {
  return (
    <>
      <div className="modal-wrap">
        <div className="dimmed" onClick={handleCloseModal}></div>
        <div className="modal-inner guide-size">
          {btnClose && (
            <button type="button" className="btn-modal-close" onClick={handleCloseModal}>
              <i className="blind">닫기</i>
            </button>
          )}
          <div className="modal-header">
            <strong>결제 취소 정보</strong>
          </div>
          <div className="modal-content">
            <div className={style.CancelConfirmTit}>결제 취소 완료</div>
            <div className={style.modalCancleWrap}>
              <div className={style.classInfoBoxWrap}>
                {orderData?.orderDetailVOList?.map((item, idx) => (
                  <div className={style.classInfoBox} key={idx}>
                    <span
                      className={style.classImg}
                      style={{
                        backgroundImage: getBackgroundImageUrl(item.thumbnailPath)
                      }}
                    ></span>
                    <div className={style.classInfo}>
                      <p className={style.classTitle}>{item.orderName}</p>
                      <p className={style.classQuantity}>수량: {item.cnt}개</p>
                      <p className={style.originalPrice}>
                        {item.originalPrice?.toLocaleString()}원
                      </p>
                      <p className={style.paymentPrice}>
                        <b>{item.paymentPrice?.toLocaleString()}</b>원
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              <div className={style.payRefundWrap}>
                <div className={style.payRefund}>
                  <strong className={style.title}>환불 내역</strong>
                  <div className={style.payRefundAmount}>
                    <div className={style.item}>
                      <strong>결제 수단</strong>
                      <p className={'payment-method'}>{cancelInfo?.paymentTypeCode}</p>
                    </div>
                    <div className={style.item}>
                      <strong>환불 상품 금액</strong>
                      <p className={style.paymentPrice}>
                        {cancelInfo?.salePrice?.toLocaleString()}원
                      </p>
                    </div>
                    <div className={style.item}>
                      <strong>할인 취소 금액</strong>
                      <p className={style.paymentPrice}>
                        {cancelInfo?.discountPrice?.toLocaleString()}원
                      </p>
                    </div>
                    <div className={style.item}>
                      <strong>배송비</strong>
                      <p className={style.paymentPrice}>
                        {cancelInfo?.deliveryPrice?.toLocaleString()}원
                      </p>
                    </div>
                  </div>
                  <div className={`${style.item} ${style.totalRefundPrice}`}>
                    <strong className={style.title}>총 환불 금액</strong>
                    <p>{cancelInfo?.refundAmount?.toLocaleString()}원</p>
                  </div>
                </div>
                <div className={style.payRefundInfo}>
                  <strong>결제취소안내</strong>
                  <ul>
                    <li>
                      결제하신 금액은 취소 즉시 환불처리됩니다. <br />
                      (환불 소요 기간은 결제 수단마다 다를 수 있음)
                    </li>
                    <li>
                      사용하신 쿠폰은 유효기간이 만료되지 않았다면 반환되며, 다시 사용하실 수
                      있습니다.
                    </li>
                    <li>
                      환불이 완료되 적용된 할인 혜택이 소멸될 수 있으며, 복구가 불가능하므로
                      신중하게 진행해 주세요.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ModalPayCancelInfo
